export const getBrowserVisibilityProp = () => {
  if (typeof document.hidden !== 'undefined') {
    return 'visibilitychange';
  }
  if (typeof document.msHidden !== 'undefined') {
    return 'msvisibilitychange';
  }
  if (typeof document.webkitHidden !== 'undefined') {
    return 'webkitvisibilitychange';
  }
  return null;
};

export const getBrowserDocumentHiddenProp = () => {
  if (typeof document.hidden !== 'undefined') {
    return 'hidden';
  }
  if (typeof document.msHidden !== 'undefined') {
    return 'msHidden';
  }
  if (typeof document.webkitHidden !== 'undefined') {
    return 'webkitHidden';
  }
  return null;
};

export const getIsDocumentHidden = () => {
  return !document[getBrowserDocumentHiddenProp()];
};
